import {
  IonButton,
  IonPage,
  IonText,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonFooter,
  IonContent,
  IonIcon,
} from '@ionic/react';
import { mailOutline } from 'ionicons/icons';
import React from 'react';
import type { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { t } from 'ttag';

import BackButton from '@components/BackButton';
import Content from '@components/Content';
import Product from '@custom-types/Product';
import RoutePath from '@custom-types/RoutePath';
import { generateRoute, getProduct } from '@services/navigation-service';
import { AppLauncher } from '~capacitor-plugins/app-launcher';
import { Browser } from '~capacitor-plugins/browser';

import { SUPPORT_EMAIL } from './service';

const Title = styled(IonText)`
  margin-bottom: 20px;
`;

const Toolbar = styled(IonToolbar)`
  --background: transparent;
`;

const Button = styled(IonButton)`
  padding: 0 16px;
  margin: 16px 0;
`;

const Icon = styled(IonIcon)`
  margin-top: 40px;
  color: #ff9e1b;
  width: 138px;
  height: 138px;
`;

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;

  ion-text {
    margin-bottom: 0.5px;
  }
`;

export type ForgotPasswordSuccessProps = RouteComponentProps<{ email: string }>;

const ForgotPasswordSuccess = ({ match }: ForgotPasswordSuccessProps) => {
  const { email } = match.params;
  const product = getProduct();

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <Toolbar>
          <IonButtons slot="start">
            <BackButton />
          </IonButtons>
        </Toolbar>
      </IonHeader>
      <IonContent>
        <Content>
          <Icon icon={mailOutline} />
          <Title>
            <h1>{t`Check Your Email`}</h1>
          </Title>
          <IonText className="ion-text-center" color="dark">
            <p>
              {t`We have sent an email to ${email} with instructions on how to reset your password.`}
            </p>
            <p>
              {t`If you don't receive the email within a few minutes, please check your spam folder.`}
            </p>
          </IonText>
        </Content>
      </IonContent>
      <IonFooter className="ion-no-border">
        <FooterContent>
          <IonText color="dark">{t`Need help?`}</IonText>
          <IonButton
            role="button"
            fill="clear"
            size="small"
            className="ion-text-capitalize"
            // skipcq: JS-0417
            onClick={async () => {
              const url = `mailto:${SUPPORT_EMAIL}`;
              if (await AppLauncher.canOpenUrl({ url })) {
                AppLauncher.openUrl({ url });
              } else {
                Browser.open({ url: `mailto:${SUPPORT_EMAIL}` });
              }
            }}
          >
            {t`Contact Support`}
          </IonButton>
        </FooterContent>
        <Button
          expand="block"
          role="button"
          fill="outline"
          routerLink={
            product === Product.LeadCapture
              ? generateRoute(RoutePath.Login)
              : generateRoute(RoutePath.LoginWithPassword, { email })
          }
        >
          {t`Back To Login`}
        </Button>
      </IonFooter>
    </IonPage>
  );
};

export default ForgotPasswordSuccess;
